import { FileReference } from '@kaizenplatform/belfast-entity';
import { AnyFieldValue } from '@kaizenplatform/hugot-entity';

import { DynamicSchemaDefinitionField } from '../generated/graphql';

const isIncompleteCreativeBriefField = (
  field: DynamicSchemaDefinitionField,
  value: AnyFieldValue,
  files: FileReference[] = [],
): boolean => {
  switch (field.type) {
    case 'SINGLE_LINE_TEXT':
    case 'MULTI_LINE_TEXT':
      // Text
      return ((value as any) as string).trim().length === 0;
    case 'SELECT_MULTIPLE':
      // Empty array
      return ((value as any) as Set<string>).size === 0;
    case 'FILES':
      // Empty array
      return files.length === 0;
    case 'POSITIVE_INTEGER':
      return value == null || (typeof value === 'string' && value.trim().length === 0);
    case 'SELECT_ONE':
    case 'TOGGLE':
    case 'FIXED':
      // Always false
      return false;
    case 'FILE_IDS':
      // CreativeBriefにFILE_IDSは存在しないのでどちらを返しても問題ない
      return true;
  }
};

export default isIncompleteCreativeBriefField;
